/** @file facet.removeEntry: removes one facet entry of an impostor (later entries are renumbered). */
import type { CommandDef } from '../apply/commandDef';
import { checkPuppet } from '../puppetDoc/checkPuppet';
import { readInput } from '../validate/readInput';
import { findEntry } from './findEntry';

/** `facet.removeEntry { drawable, entry }` → `{}`; inverse: `facet.addEntry` of the entry at its index. */
export const facetRemoveEntryCommand: CommandDef<'facet.removeEntry'> = {
  name: 'facet.removeEntry',
  /** Checks the raw input (VALIDATION under the input path). */
  validate: (input, path) => {
    const r = readInput(input, path, ['drawable', 'entry']);
    return { drawable: r.str('drawable'), entry: r.int('entry', { min: 0 }) };
  },
  /** Applies the command to the draft and returns its result and inverse. */
  apply: (draft, input, ctx) => {
    const { impostor, entry } = findEntry(draft.puppet, input.drawable, input.entry);
    impostor.facets.splice(input.entry, 1);
    checkPuppet(draft, ctx);
    return { result: {}, warnings: [], inverse: [{ name: 'facet.addEntry', input: { drawable: input.drawable, entry: structuredClone(entry), index: input.entry } }] };
  },
};
